import React from 'react'

import { Frame, FrameProps, useFrameContext } from './Frame'

export { useFrameContext }

/**
 * @file this is a fork from https://github.com/hermantolim/react-frame-component
 *
 * @todo remove this frame implementation from app builder
 */
export const ReactFrame = React.forwardRef<HTMLIFrameElement, FrameProps>((props, ref) => (
  // @ts-ignore
  <Frame {...props} forwardedRef={ref} />
))

ReactFrame.displayName = 'ReactFrame'
